

import locationsReducer from './LocationsReducer'
export { locationsReducer }

export * from './LocationsActions'



// WEBPACK FOOTER //
// ./src/store/locations/index.js